const Pagination = ({ className }) => {
  return <p className={className}>{'1 2 3 >>'}</p>;
};

export default Pagination;
